import { toast } from 'material-react-toastify';

import { coachApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { coachKeys } from '@/lib/query/keys/coach';
import { Coach } from '@addmile/backend-client';
import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';

export const useCoachByEmail = (email: string | null | undefined) => {
  return useQuery<Coach | undefined>({
    queryKey: email ? coachKeys.detail(email) : [],
    queryFn: async () => {
      if (!email) return undefined;
      try {
        const token = await getAuthToken();
        const { data: coach } = await coachApi.searchCoach(email, withAuthHeader(token));

        return coach;
      } catch (error) {
        Sentry.captureException(`Failed to fetch coach: ${error.message}`);
        toast.error(`Failed to fetch coach: ${error.message}`);
        return undefined;
      }
    },
    enabled: !!email,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
